import { schema } from 'normalizr';

export const terminal = new schema.Entity('terminals');

export const terminalList = new schema.Array(terminal);
